import { string, shape, oneOfType } from 'prop-types';
import context from '../serverContext';

// TODO: remove this file?

/**
 * @example
 * <Experiment name="PL_PI1_ExperimentName" variation="Control" type="default">
 *   <Component {...props} />   OR   <p>HTML markup</p>
 * </Experiment>
 *
 * <Experiment condition="PL_PI1_ExperimentName.A|PL_PI1_OtherExperiment.B">
 *   <Component {...props} />   OR   <p>HTML markup</p>
 * </Experiment>
 */
const Experiment = props => {
  const experiments = context.experiments;
  const name = props.name;
  const variation = props.variation;
  const condition = props.condition;
  const type = props.type;

  if (name && variation) {
    if (experiments[name] === variation || (!experiments[name] && type === 'default')) {
      return props.children;
    }
  }

  if (condition) {
    let conditionalVariation = false;

    condition.split('|').forEach(testName => {
      const expName = testName.split('.')[0];
      const expVariation = testName.split('.')[1];

      if (experiments[expName] === expVariation || (!experiments[expName] && type === 'default')) {
        conditionalVariation = true;
      }
    });

    if (conditionalVariation) {
      return props.children;
    }
  }

  return null;
};

Experiment.propTypes = {
  name: string,
  variation: string,
  condition: string,
  type: string,
  children: oneOfType([shape(), string]).isRequired,
};

Experiment.defaultProps = {
  name: '',
  condition: '',
  type: '',
  variation: '',
};

Experiment.contextTypes = {
  experiments: shape(),
};

export default Experiment;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');